// extracted by mini-css-extract-plugin
export default {"product":"CU","image_carousel":"EU","main_gallery":"FU","personalized_badge":"GU","greens_badge":"HU","arrows":"IU","slide":"JU","thumbnail_gallery":"KU","swiper-slide":"LU","learn_more":"MU","product_info":"NU","description_wrapper":"OU","checklist":"PU","checklistItem":"QU","delivery_freq":"RU","tooltip_button":"SU","key_benefits":"TU","benefit_item":"UU","ingredients":"VU","ingredient_item":"WU","active_slide":"XU","benefits_list":"YU","checkmark":"ZU"};
    if(module.hot) {
      // 1713969936510
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  